module.exports = __webpack_public_path__ + "static/media/problems.13292efe.png";